import OrganizationProfile from "@/features/organizations/profile";

const Organization = () => {
  return <OrganizationProfile />;
};

export default Organization;
